__turbopack_context__.v({
  "SingleProject": "SingleProject-module-sass-module__n4NfFq__SingleProject",
});
